import React, {useMemo, useState} from 'react';
import {
  Card,
  CardHeader,
  CardContent,
  Divider,
  Collapse, Link,
} from '@material-ui/core';
import {ExpandLess, ExpandMore} from "@material-ui/icons";
import {makeStyles} from "@material-ui/styles";
import HistoricalBlueprintFields from "./pwtForm/HistoricalBlueprintFields";

const useStyles = makeStyles((theme) => ({
  formGroup: {
    padding: theme.spacing(2, 0)
  },
  addNewRelationshipLink: {
    textTransform: 'capitalize',
    textDecoration: 'none',
    fontWeight: '600',
    cursor: 'pointer',
    marginBottom: '16px',
    display: 'inline-block',
    '&:hover': {
      textDecoration: 'none',
    }
  },
}));

const HistoricalBlueprintsSection = ({ team, open, handleOnChangeInField, handleOpenMaTransaction }) => {
  const classes = useStyles();
  const [expandHistoricalBlueprint, setExpandHistoricalBlueprint] = useState(open);
  const currentParentCompanyOptions = useMemo(() => {
    const options = [];
    if (team?.crd_id) {
      options.push({ id: team.crd_id, name: `${team.firm_name} (${team.crd_id})` });
    }
    const blueprints = team?.historical_blueprints?.filter(b => !b._destroy) || [];
    blueprints.forEach(bp => {
      if (bp.current_parent_company_crd_id && !options.some(o => o.id === bp.current_parent_company_crd_id)) {
        options.push({ id: bp.current_parent_company_crd_id, name: bp.current_parent_company_name || String(bp.current_parent_company_crd_id) });
      }
    });
    return options;
  }, [team]);

  const toggleExpandHistorical = () => {
    setExpandHistoricalBlueprint(!expandHistoricalBlueprint);
  }

  function handleAddNestedFields(nestedFieldsName) {
    let currentData = [...team[nestedFieldsName]];

    if(currentData?.filter(historical => !historical._destroy).length === 5 ){
      alert('You can only add up to 5 New Historical Events.');
      return;
    }

    const field = {
      id: null,
      _destroy: false,
      previous_parent_company_crd_id: null,
      current_parent_company_crd_id: team.crd_id,
      year : null,
      month : null,
      previous_team_name: '',
      current_team_name: team.team_name,
      is_formerly_registered: false,
    };

    currentData.push(field);
    handleOnChangeInField(nestedFieldsName, currentData);
  }

  function handleRemoveNestedFields(nestedField, nestedFieldsName) {
    nestedField._destroy = true;
    handleOnChangeInField(nestedFieldsName, team[nestedFieldsName]);
  }

  function handleNestedFieldChange(nestedFieldsName, item, field, value) {
    item._destroy = false;
    item[field] = value;
    handleOnChangeInField(nestedFieldsName, team[nestedFieldsName]);
  }

  const activeBlueprints = team.historical_blueprints?.filter(historical => !historical._destroy) || [];
  const lastActiveIndex = activeBlueprints.length - 1;

  const initialCurrentParentCompanyOptions = [...currentParentCompanyOptions];

  const getPreviousValues = (activeBlueprints, index) => {
    const previous = activeBlueprints[index - 1];
    const defaultYear = previous?.year;
    const defaultCurrentParentCompany = previous?.previous_parent_company_crd_id
        ? {
          id: previous.previous_parent_company_crd_id,
          name: previous.previous_parent_company_name || `${previous.previous_team_name} (${previous.previous_parent_company_crd_id})`,
        }
        : null;

    return {
      yearOptions: _.range(defaultYear || new Date().getFullYear(), 1949),
      currentParentCompany: defaultCurrentParentCompany,
    };
  };

  const renderHistoricalField = (historical, index, lastIndex) => {
    const { yearOptions, currentParentCompany } = getPreviousValues(activeBlueprints, index);

    let optionsForCurrentParent = index === 0
        ? initialCurrentParentCompanyOptions
        : currentParentCompany ? [currentParentCompany] : [];

    if (historical.current_parent_company_crd_id && !optionsForCurrentParent.some(o => o.id === historical.current_parent_company_crd_id)) {
        optionsForCurrentParent = [...optionsForCurrentParent, {
            id: historical.current_parent_company_crd_id,
            name: historical.current_parent_company_name || String(historical.current_parent_company_crd_id),
        }];
    }

    return (
        <React.Fragment key={`historical-blueprint-edit-${index}-${historical.id}`}>
          <HistoricalBlueprintFields
              historicalBlueprint={historical}
              handleNestedFieldChange={handleNestedFieldChange}
              handleRemoveNestedFields={handleRemoveNestedFields}
              team={team}
              currentParentCompanyOptions={optionsForCurrentParent}
              yearOptions={yearOptions}
              index={index}
              lastRow={index === lastIndex}
              handleOpenMaTransaction={handleOpenMaTransaction}
          />
          {index < lastIndex && <Divider style={{ margin: '50px 0' }} />}
        </React.Fragment>
    );
  };

  return(
    <React.Fragment>
      <Card style={{marginTop: '24px'}}
      >
        <CardHeader className='cursor-pointer' title={
            <span>
              <span>Historical Blueprint</span>
              <span className='float-right'>
                {
                  expandHistoricalBlueprint ? <ExpandLess /> : <ExpandMore />
                }
              </span>
            </span>
          } onClick={toggleExpandHistorical}
        />
        <Divider />
        <CardContent style={{padding: `${expandHistoricalBlueprint ? '20px' : 0}`, overflowY: 'auto'}}>
          <Collapse in={!!expandHistoricalBlueprint}>
            {
                    <div className={classes.formGroup}>
                      {activeBlueprints.map((historical, index) =>
                          renderHistoricalField(historical, index, lastActiveIndex)
                      )}
                      <Link to='' className={classes.addNewRelationshipLink} onClick={() => handleAddNestedFields('historical_blueprints')}>+ New Historical Event</Link>
                    </div>
            }
          </Collapse>
        </CardContent>
      </Card>
    </React.Fragment>
  )
}

export default HistoricalBlueprintsSection;